import React, {Component} from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {systemBaseEvent} from "../../../base/baseEvent";
import {getInfoFromLocalStorage} from "../../../actions";
import Editor from "../Editor";
import ButtonList from "../components/activitiAndBtn/ButtonList";
import LinkCheck from "../components/pluginsSpace/linkCheck/linkCheck";
import SyncModal from "../../components/syncModal/syncModal";
import MediaList from "../../newsContribute/component/modal/mediaList";
import {EditorInformationOfRmEditor as EditorInformation} from "./EditorInformationOfRmEditor";
import {formItemSizeConfig} from "../webEditor/form/information-config";
import EditorPublishInformation from "../components/EditorPublishInformation";
import {base64Encode} from "../../../utils";
import {removeContentSecurity} from "../floatTool/securityCheck";
import {Button, Input, message, Modal} from "antd";
import {Scrollbars} from "react-custom-scrollbars";

const topBtnHeight = 64;//顶部按钮高度
const {TextArea} = Input;
class RmAppEditor extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,//稿件id和uuid
            contentText: "",//稿件内容
            activityOption: {},// 审核流所需参数
            informationStatus: true,//基本信息的展开状态
            editorShowStatus: true,//编辑器输入区域显示状态
            mediaId: "",
            columnId: "",
            storyType: "",
            checkMainColumn: false, // 校验主栏目回显
            showRemarks: false,
            remarks:"",
            publishMediaListModalVisible: false, // 查看发布弹窗
            publishMediaListData: [], // 发布链接列表
            showPublishMediaListModalBtn: false, // 是否展示查看发布按钮
            isLockedData:{},//锁住的信息
            mediaName: ""
        };

        if (this.urlParams) {
            let columnId = this.urlParams.columnId;
            let mediaId = this.urlParams.mediaId;
            if(!mediaId && this.urlParams.mediaFusion && this.urlParams.mediaFusion.mediaId) {
                mediaId = this.urlParams.mediaFusion.mediaId;
            }
            let checkMainColumn = this.urlParams.checkMainColumn;
            if(mediaId || columnId) {
                this.setIds({mediaId,columnId,checkMainColumn});
            }
        }
        window.ueditor.dataType = "rmapp";
        window.ueditor.setCurrentInformation = (data)=>{
            //融媒编辑器的类型只会是0 ，不会是1与后端沟通过。
            data.type=0;
            this.setCurrentInformation(data);
        };

        if(this.state.id){
            systemBaseEvent.syncPlaybackExec("editorUpdateData");//广播编辑器中当前是修改稿件
        }
        systemBaseEvent.syncPlaybackExec("editorIdChange", {editorId: this.props.id});//广播编辑器中的当前id
        systemBaseEvent.syncPlaybackExec("editorAjaxShowDataUrlChange", "/cm-sites-mmp/mf/mediaFusion/");//广播ajax获取数据的方式
    }

    componentWillMount() {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        if(!id) {
            this.initActivitiConfig({});
        }
    }

    /**
     * 设置父页面传过来的参数作为编辑器中的数据回显
     */
    initParentData() {
        if (this.urlParams) {
            this.state.operateType = this.urlParams.operateType;
            this.state.storyId = this.urlParams.storyId; // 可能是投稿过来的
            if(this.urlParams.mediaFusion){
                this.state.mediaFusion = this.urlParams.mediaFusion;
                this.setStoryByData(this.state.mediaFusion);
            }
            this.setState({});
        }
    }
    activitiBtns;
    /**设置流程配置*/
    async initActivitiConfig(story,call) {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        this.state.id = id;
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        let userId = (window.currentUser && window.currentUser.id) ? window.currentUser.id : "";
        let publishConfig = this.sysConfigGetValueByKey("rmapp.publishBtn.exclude", "已发布");
        let mustNotShowPublishBtn1 = (story.statusName && publishConfig.indexOf(story.statusName) > -1) ? false : true;
        let mustNotShowPublishBtn2 = that.urlParams && that.urlParams.mustNotShowPublishBtn ? that.urlParams.mustNotShowPublishBtn : false;
        // 判断操作权限start
        let showBtnFlag = false;
        let currentMediaList = getInfoFromLocalStorage("currentMediaList");
        if(!currentMediaList) {
            currentMediaList = await this.getCurrentMediaList()
        }
        if(currentMediaList && currentMediaList.length) {
            if(this.state.mediaId) {
                if(currentMediaList.find(item=>item&&item.mediaList&&item.mediaList.find(item2=>item2.id===this.state.mediaId))){
                    let currentMediaTypeData = currentMediaList.find(item=>item&&item.mediaList&&item.mediaList.find(item2=>item2.id===this.state.mediaId));
                    let currentMedia = currentMediaTypeData.mediaList && currentMediaTypeData.mediaList.length > 0 && currentMediaTypeData.mediaList.find(item=> item.id===this.state.mediaId);
                    this.state.mediaName = (currentMedia && currentMedia.name) || "";
                    showBtnFlag = true;
                }
            } else {
                showBtnFlag = true;
            }
        }
        // 判断操作权限end

        // 重置流程条件start
        let againFlag = false;
        if(!id && that.urlParams.storyId) {
            // 当前稿件无id，但是投稿稿件存在id，需要用旧id重启流程
            againFlag = true;
            id = that.urlParams.storyId;
        }
        let reloadStatus = this.sysConfigGetValueByKey("rmapp.activiti.reload.status", "");
        if(story.statusName && reloadStatus.indexOf(story.statusName) > -1) { // 弃用状态重启审核流
            againFlag = true;
        }
        let activitiConf = this.urlParams ? {type: this.urlParams.activitiConfName} : null;
        // 如果草稿稿件可以被创建人之外的人看到，则需要手动控制审核流不要重启
        if(story && story.statusName === "草稿" && story.submitter !== userId) {
            // 当稿件状态为草稿时，审核流会自动重启，此时将activitiConf置空则审核流不重启
            activitiConf = null
        }
        // 重置流程条件end
        this.state.activityOption = {
            id,//流程id
            activitiConf,//流程conf
            pojoName: 'mediaFusion',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {
                // call({code: 1});
                // call({code: 0, log: "非投稿稿件！"});
                // call({code: -1, log: "未获取到采访任务信息，请重新打开再试！"});
                /**
                 * 弃用
                 */
                abandon: (item, call) => {
                    if(id) {
                        call({code: 1});
                    } else {
                        call({code: 0, log: "新增文章没有弃用权限！"});
                    }
                },
                /**
                 * 是否显示撤回按钮
                 */
                callBackBtnShow: (item, call) => {
                    // 素材中心稿件标题进入的稿件
                    if(that.state.operateType && that.state.operateType === "contribute") {
                        let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.goBack.states", "已返回写稿人,返回写稿人");
                        // 稿件状态为返回写稿人
                        if(story && story.statusName && activitiConfName.includes(story.statusName)) {
                            call({code: 0, log: "不显示撤回按钮！"});
                            return
                        }
                    }
                    call({code: 1});
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                /**
                 * 返回流程初始创建人js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                returnsProcessCreator: (activiti, buttonConf, call) => {
                    let myId = (window.currentUser && window.currentUser.account) ? window.currentUser.id : "";
                    that.getProcessHistory(id,(list)=>{
                        if(list&&list.length) {
                            let userInfo = list.at(-1) || {};
                            let userId = userInfo.operatorUserInfo.userId;
                            let userName = userInfo.operatorName;
                            let deptId = userInfo.operatorUserInfo.deptId;
                            if (myId === userId) {
                                message.warning("当前稿件写稿人与当前操作人是同一人，无需返回");
                                window.loading.hide();
                                return false;
                            }
                            activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                                id: userId,
                                deptId
                            }];
                            call({code: 1, log: "查询到返回者为：" + userName});
                        } else {
                            message.warning("审核流记录查询失败！");
                            window.loading.hide();
                        }
                    });
                },
                /**
                 * 返回稿件创建人js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                setSourceUser: (activiti, buttonConf, call) => {
                    let myId = (window.currentUser && window.currentUser.account) ? window.currentUser.id : "";
                    if (myId === this.mediaFusion.submitter) {
                        message.warning("当前稿件写稿人与当前操作人是同一人，无需返回");
                        window.loading.hide();
                        return false;
                    }
                    activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                        id: this.mediaFusion.submitter,
                        name: this.mediaFusion.submitterName,
                    }];
                    call({code: 1, log: "查询到返回者为：" + this.mediaFusion.submitter});
                },

                /**
                 * 撤稿前置js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callActRevert: function (activiti, buttonConf, call) {
                    activiti.terminate.call(activiti, function (res) {
                        if (res == true) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if(res){
                                    message.warning("流程已撤回，稿件变为草稿状态", 1, ()=>{
                                        activiti.submitOK();
                                    });
                                }
                            })
                        }
                    });
                },
            },//流程按钮事件前置js
            saveFunction: that.saveStory,//稿件保存方法
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            publish: that.publish,
            onSubmitOK: function (activiti) {
                that.refresh(activiti)
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            showRemarks: (remarks) => {
                if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver:(btns)=>{
                this.activitiBtns = btns;
                this.setState({});
            },
            // 控制前端发布按钮的显隐
            mustNotShowPublishBtn: !!(mustNotShowPublishBtn1 || mustNotShowPublishBtn2),
            showBtnIcon: true,
            btnType: "editor",
            showLockCall: (data) => {
                // data={status: true, id: this.messageId}  true 加锁成功，只有当前人可编辑，  false 加锁失败，不可编辑，
                // 如果加锁失败，则开启遮罩
                if (!data.status) {
                    this.Editor.showLockMask(data);
                    this.state.isLockedData = data;
                    this.setState({})
                }
            },
            chooseFilterObject: function (users, call) {
                if (!users || users.length < 1) {
                    call && call(users);
                    return false
                }
                let mediaInfo = that.getChooseFilterObject();
                if(!mediaInfo) {
                    message.warning("过滤媒体权限失败，请先选择主栏目");
                    window.loading.hide();
                    return false
                }
                let receivers = users.map(item=>({
                    deptId: item.deptData[0]._id,
                    userId: item._id,
                }));
                call && call(receivers);
            },
            checkForm: that.checkForm
        };
        this.setState({});
        call&&call(this.state.activityOption)
    }

    getChooseFilterObject = () => {
        let publishData = this.getPublish();
        let {rmSelectColumn={}} = publishData;
        let mainColumn = rmSelectColumn && rmSelectColumn.mainColumn||{}; // 主栏目
        let columnId = mainColumn.treeId || mainColumn.id;
        let mediaId = mainColumn.mediaId;
        if(!(mainColumn && columnId && mediaId)) {
            window.loading.hide();
            return false
        } else {
            return {
                columnId,
                mediaId
            }
        }
    };

    getProcessHistory = (id, call) => {
        if (!id && call) {
            call([]);
            return false
        }
        this.request({
            url: "/cm-sites-sys/process/getProcessHistory",
            method: "post",
            body: {bizKey: id},
            callBack: (res) => {
                if (res && res.length) {
                    call(res)
                } else {
                    call([])
                }
            },
            errorCallBack: (e) => {
                window.loading.hide();
                console.log(e.toString())
            }
        })
    };

    mediaFusion = {};
    componentDidMount() {
    }

    setIds = ({mediaId,columnId,checkMainColumn}) => {
        this.state.mediaId = mediaId;
        this.state.columnId = columnId;
        this.state.checkMainColumn = checkMainColumn;
    };

    componentWillUnmount() {
        // 销毁postMessage监听
        this.destroyPostMessage("EditorInformationOfRmAppEditor")
    }

    refresh = (activiti) => {
        let hash = window.location.hash.split('/');
        if(this.state.id && !(hash[hash.length - 1] && hash[hash.length - 1].length>1)) {
            hash[hash.length - 1] = this.state.id;
        }
        this.callPostMessage({message:'请求刷新父页面'});
        window.location.hash = hash.join('/');
        activiti&&activiti.load.end();
        window.location.reload();
    };

    // 渲染稿件编辑器
    render() {
        return (
            <Editor
                // Editor组件暴露
                ref={(Editor) => {this.Editor = Editor}}
                // 动态参数（传递到子组件中）
                dynamicParams={{
                    editorId:this.state.id,
                    oldId:this.state.storyId,
                    // findOldUuid: this.findOldUuid
                }}
                // 流程按钮组件
                editorActBtn={this.renderActBtn()}
                // 稿件基本信息组件
                editorInformation={this.renderInformation()}
                // 稿件栏目设置模块
                editorRightModule={this.renderEditorPublishInformation()}
                // 编辑器加载完毕的回调
                onEditorLoadOver={()=>{
                    // 向父页面请求媒体参数或稿件参数
                    // this.callPostMessage({
                    //     message: "请求媒体参数"
                    // });
                    window.ueditor.afterSaveDataFun = [];
                    window.ueditor.addAfterSaveDataFun = function(fun){
                        window.ueditor.afterSaveDataFun.push(fun);
                    };
                    //接收参数去渲染数据  这里只能放在这里，因为必须等到编辑器加载完成了之后，才要把内容放在编辑器中
                    this.initParentData();
                    //接收id去渲染数据
                    this.getStoryById()
                }}
                // 编辑器内容改变的回调
                onEditorContentChange={(content)=>{
                    this.setState({contentText:this.getEditContentText()})
                }}
                // 基本信息展开和关闭的回调
                onInformationStatusCallBack={(status) => {this.setState({informationStatus: status})}}
                // 表单展开状态
                informationStatus={this.state.informationStatus}
                // 编辑器输入区域显示状态
                editorShow={this.state.editorShowStatus}
                // 编辑器工具栏上的插件配置
                pluginsSpaceConfig={["securityPlugin", "storyImport", "storyLayout"]}
                hideHyperToolContent={true}
            />
        )
    }

    getActBtnListData (){
        // 这里不要限制打印按钮
        let {activityOption} = this.state;
        if(!activityOption.pojoName) {
            return null;
        }
        let that = this;
        // 流程按钮需要的参数
        let buttonListData = {
            topBtnHeight,
            activityOption,
            saveStory: that.saveStory,
            showSave: (()=>{
                if(this.activitiBtns && (this.activitiBtns.length > 0)){
                    let configBtns = this.sysConfigGetValueByKey("rmapp.editor.saveBtn.mutex.activiti.btn", "撤回,返回修改").split(",");
                    let result = true;
                    this.activitiBtns && this.activitiBtns.map(item=>{
                        if(configBtns.indexOf(item.name) > -1){
                            result = false;
                        }
                    });
                    if(!this.mediaFusion.statusName || (this.mediaFusion.statusName === "草稿" && this.mediaFusion.submitter === window.currentUser.id)) {
                        result = true;
                    }
                    return result;
                }
                return false;
            })(),
            showPreview: false,
            showPrint:false,
            printCall:this.printCall,
            showRemarks: this.state.showRemarks,
            showRemarksCall: this.showRemarksCall,
            showPublishMediaListModalBtnCall: that.showPublishMediaListModalBtnCall, // 查看发布 按钮
            showPublishMediaListModalBtn: that.state.showPublishMediaListModalBtn, // 查看发布 按钮
        };
        if (this.urlParams && this.urlParams.hideBtn) {
            buttonListData.activityOption.showBtnFlag = false;
            buttonListData.activityOption.mustNotShowPublishBtn = true;
            buttonListData.showPreview = false;
            buttonListData.showPublishMediaListModalBtn = false;
        }
        return buttonListData;
    };

    //渲染流程按钮
    renderActBtn = () => {
        let buttonListData = this.getActBtnListData();
        let isLockedData={isLockedData:this.state.isLockedData};
        return (
            <>
                {buttonListData ?
                    (
                        <>
                            <ButtonList {...buttonListData}{...isLockedData}/>
                            <LinkCheck ref={ref => this.LinkCheck = ref}/>
                            {this.renderViewPublishModal()}
                        </>
                    )
                    : ""}
                <SyncModal ref={ref=>this.syncModal=ref}/>
            </>
        );
    };

    renderViewPublishModal = ()=>{
        return (
            <Modal
                title={"查看发布"}
                footer={null}
                visible={this.state.publishMediaListModalVisible}
                onOk={()=>{this.setState({publishMediaListModalVisible:false})}}
                onCancel={()=>{this.setState({publishMediaListModalVisible:false})}}
                // maskClosable={false}
            >
                <Scrollbars
                    autoHeight={true}
                    autoHeightMax={500}
                    autoHide={true}
                >
                    <MediaList group={this.state.publishMediaListData} hideMediaTitle={true}/>
                </Scrollbars>
            </Modal>
        )
    };

    showPublishMediaListModalBtnCall = () => {
        this.setState({publishMediaListModalVisible:true});
    };

    // 渲染稿件基本信息
    renderInformation = () => {
        return(
            <EditorInformation
                // 配置文件（输入框占比）
                informationConfig={{
                    text: 8,
                    textarea: 24,
                    date: 8,
                    select: 8,

                    default:8,
                    summary:24,
                    author:8,
                    phone:8,
                    contact:8,
                    photography:8,
                    camera:8,
                    editor:8,
                    url: '/cm-sites-mmp/mf/getBaseField',
                    showFTitle:false,
                    hideTitleStyleBtn: true,
                    hideUpload: true
                }}
                // 配置文件（输入框大小）
                formItemSizeConfig={formItemSizeConfig}
                // 基本信息展开状态
                informationStatus={this.state.informationStatus}
                // 编辑器内容
                contentText={this.state.contentText}
                // 标题的加号
                titleAddOrMinus={(call) => {
                    this.titleAddOrMinus(call)
                }}
                onLinkCheckedCall={(status)=>{
                    this.setState({editorShowStatus:status})
                }}
                formItemOnChange={(key, value)=>{//表单内容变化时通知
                    systemBaseEvent.asyncExec("editorInformationItemChange", {key, value});
                }}
                // 点击标题
                dynamicParams={{
                    editorId: this.state.id,
                    mediaId: this.state.mediaId,
                    columnId: this.state.columnId,
                }}
                ref={(ref) => {
                    this.editorInformation = ref;
                    window.ueditor.getInformation = (check)=>this.editorInformation.getInformation(check);
                    window.ueditor.delAttachByMd5 = (md5)=>this.editorInformation.delAttachByMd5(md5);
                    window.ueditor.setFocus = (labelKey)=>this.editorInformation.setFocus(labelKey);
                    window.ueditor.informationSelect = (labelKey,sIndex,eIndex) => this.EditorInformationOfRmEditor.selectText(labelKey,sIndex,eIndex);
                }}
            />
        )
    };

    // 渲染稿件栏目模块
    renderEditorPublishInformation= () => {
        return (
            <EditorPublishInformation
                ref={(ref) => {
                    this.editorPublishInformation = ref
                }}
                title={'发布设置'}
                informationConfig={{
                    modules: [
                        'rmSelectColumn',
                        // 'rmSynchronousContribute',
                        'rmOtherAttributes',
                        'rmPublisher'
                    ]
                }}
                dynamicParams={{
                    editorId: this.state.id,
                    mediaId: this.state.mediaId,
                    columnId: this.state.columnId,
                    checkMainColumn: this.state.checkMainColumn,
                    setDynamicParams: this.setDynamicParams
                }}
            />
        )
    };

    setDynamicParams = (dynamicParams) => {
        if(dynamicParams) {
            for(let i in dynamicParams) {
                this.state[i] = dynamicParams[i]
            }
            this.setState({});
        }
    };

    titleAddOrMinus(call) {
        this.setState({
            informationStatus: true,
        },()=>{
            call&&call(true)
        })
    }

    /**
     * 获取稿件
     */
    getStoryById = () => {
        let that = this;
        if(!(this.props.id && this.props.id.length>1 && this.props.id != 'null' && this.props.id != 'undefined')){
            this.Editor&&this.Editor.showData&&this.Editor.showData(this.mediaFusion);
            return;
        }
        this.request({
            url: "/cm-sites-mmp/mf/mediaFusion/"+this.props.id,
            body: {webNewsId:this.props.id},
            callBack: function (res) {
                if (res) {
                    systemBaseEvent.syncPlaybackExec("editorDataChange", res);
                    if (res && (res.statusName == "发布" || res.statusName == "已发布")) {
                        that.showColumnsModel(res);
                        that.setStoryByData(res);
                    }else{
                        that.setStoryByData(res)
                    }
                } else {
                    // message.error('稿件加载失败！');
                }
            },
            errorCallBack: function (res) {
                message.error('稿件加载失败！');
            }
        });
    };

    showColumnsModel = (data) => {
        if(data){
            if(data.statusName == "发布" || data.statusName == "已发布") {
                if(data.deliveryMediaFusionList && data.deliveryMediaFusionList.length) {
                    let columnId = this.urlParams.columnId ? this.urlParams.columnId*1 : "";
                    let mediaId = this.urlParams.mediaId ? this.urlParams.mediaId : "";
                    if(
                        (columnId && data.columnId && columnId!==data.columnId) ||
                        (mediaId && data.mediaId && mediaId!==data.mediaId)
                    ) {
                        //当前不是主栏目 (媒体不同时也认为不是主栏目，存在不同媒体相同栏目id的情况）
                        let that = this;
                        let message = <div>检测到该文章是在<span style={{fontWeight: 700}}>{data.columnName}</span>栏目下发布并同时发布至当前栏目中的，是否要编辑原文章？</div>;
                        that.syncModal.confirm({
                            title: "信息",
                            width: 600,
                            content: message,
                            okText: "确定",
                            cancelText: "取消",
                            footer: <div>
                                <Button type={'primary'} onClick={()=>{that.syncModal.destroy();}}>编辑原文章</Button>
                                <Button onClick={()=>{window.close();}}>取消编辑</Button>
                            </div>,
                            onOk: () => {
                                that.syncModal.destroy();
                            },
                            onCancel: () => {
                                that.syncModal.destroy();
                                window.close();
                            }
                        });
                    }
                }
            }
        }
    };

    setStoryByData = (data) => {
        this.state.rmAppContent = data;
        this.mediaFusion = data;
        this.Editor&&this.Editor.showData&&this.Editor.showData(this.mediaFusion);
        // 回显主栏目
        let mediaId= data.mediaId;
        let columnId= data.columnId;
        // 当前栏目和主栏目不是一码事
        // 通过session传进来的栏目id是用来自动回显栏目的，如果此时稿件数据中本身有栏目，则取稿件中的栏目id.
        // 目前编辑器中没有什么地方非要用到当前栏目是哪一个，除了新增网站稿件时需要。
        this.setMainColumn({columnId,mediaId});
        this.setIds({mediaId,columnId,checkMainColumn:true});
        // 回显表单信息
        if(!data.variableFields){
            data.variableFields = {};
        }
        data.variableFields.label = data.tagNames;
        this.setCurrentInformation(data);
        // 回显发布设置
        this.setPublish({
            rmSelectColumn: {
                deliveryNews: data.deliveryMediaFusionList||[],
                mainColumn: {
                    columnId: data.columnId,
                    mediaId: data.mediaId,
                    mediaName: data.mediaName,
                    title: data.columnName,
                }
            },
            rmOtherAttributes: {
                // 是否置顶 int
                top: data.top,
                // 是否推荐 int
                recommend: data.recommend,
                // 量 int
                initViewNum: data?.variableFields?.initViewNum,
                viewNum: data.viewNum,
            },
            rmPublisher: data,
            rmSynchronousContribute: data.targetIds
        });
        // 回显编辑器内容
        this.setContent(data.content);
        // 重置流程参数
        this.initActivitiConfig(data);
        this.setState({});
    };
    // 查看备注回调
    showRemarksCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea value={that.state.remarks} placeholder={"请输入"} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}
                               ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
            okText: "确定",
            cancelText: "取消",
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onOk: () => {
                that.syncModal.destroy();
            },
            onCancel: () => {
                that.syncModal.destroy();
            }
        });
    }

    publishData = {};

    checkForm = (activiti, call) => {
        let that = this;
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.publish.states", "发布,已发布");
        let isPublish = statusNameTemp && activitiConfName.indexOf(statusNameTemp)>-1;

        // 获取编辑器内容===================start
        let content = this.getEditContent();

        // 获取编辑器内容 ================end

        // 获取基础属性====================start
        let currentInformation = this.getCurrentInformation();
        if(!currentInformation) {// 基本信息校验
            window.loading.hide();
            return false
        }
        if(this.mediaFusion.variableFields){
            currentInformation.variableFields.formatId = this.mediaFusion.variableFields.formatId;
        }
        // 获取基础属性========================end

        // 跳转链接
        if(currentInformation.linkurl&&currentInformation.linkurl.length>0){
            content = ""
        } else {
            if(!content) {
                window.loading.hide();
                message.warning("请填写内容！");
                return false
            }
            if(content.indexOf("wordimg.png") !== -1){
                window.loading.hide();
                message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
                return false
            }
        }
        // 获取发布设置start
        let publishData = this.getPublish();
        let {rmSelectColumn} = publishData;
        let selectColumn = rmSelectColumn;
        if(!selectColumn) {
            return false
        }
        let mainColumn = selectColumn&&selectColumn.mainColumn||{}; // 主栏目
        let columnId = mainColumn.treeId || mainColumn.id;
        let mediaId = mainColumn.mediaId;

        // 获取发布设置end
        // 栏目信息校验
        // 网站稿件编辑器在推进的时候必须选择主栏目，否则稿件丢失
        if(!(mainColumn && columnId && mediaId)) {
            window.loading.hide();
            return (
                message.destroy(),
                    message.warning("请先选择主栏目")
            )
        }
        call&&call()
    };

    /**
     * 稿件保存
     */
    saveStory = (activiti, call) => {
        let that = this;
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.publish.states", "发布,已发布");
        let isPublish = statusNameTemp && activitiConfName.indexOf(statusNameTemp)>-1;

        // activiti&&activiti.load&&activiti.load.start();
        // 获取编辑器内容===================start
        let content = this.getEditContent();
        // 获取编辑器内容 ================end

        // 获取基础属性====================start
        let currentInformation = this.getCurrentInformation();
        if(!currentInformation) {// 基本信息校验
            window.loading.hide();
            call&&call(false);
            return false
        }
        if(this.mediaFusion.variableFields){
            currentInformation.variableFields.formatId = this.mediaFusion.variableFields.formatId;
        }
        // 获取基础属性========================end

        //校验标题图
        if(currentInformation.titlePicShowType && currentInformation.titlePicShowType === "threeSmall" && currentInformation.titlePicList.length && currentInformation.titlePicList.length < 3) {
            window.loading.hide();
            message.warning("请上传三张图片！");
            call && call(false);
            return false;
        }

        // 跳转链接
        if(currentInformation.linkurl&&currentInformation.linkurl.length>0){
            content = ""
        } else {
            if(!content) {
                window.loading.hide();
                message.warning("请填写内容！");
                call && call(false);
                return false
            }
            if(content.indexOf("wordimg.png") !== -1){
                window.loading.hide();
                message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
                call&&call(false);
                return false
            }
        }

        // 获取稿件id
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';

        // 获取发布设置start
        let publishData = this.getPublish();
        let {rmSelectColumn,rmOtherAttributes={},rmSynchronousContribute=[], rmPublisher} = publishData;
        let selectColumn = rmSelectColumn;
        let otherAttributes = rmOtherAttributes;
        if(!selectColumn) {
            call&&call(false);
            return false
        }
        let mainColumn = (selectColumn && selectColumn.mainColumn) || {}; // 主栏目
        let columnId = mainColumn.treeId || mainColumn.id;  //mmp服务和pms服务取的字段不一样
        let mediaId = mainColumn.mediaId;
        let columnName = mainColumn.title;
        let deliveryNews = (selectColumn && selectColumn.deliveryNews) || []; // 同步发布栏目

        // 获取发布设置end
        // 栏目信息校验
        // 网站稿件编辑器在推进的时候必须选择主栏目，否则稿件丢失
        if(!(mainColumn && columnId && mediaId)) {
            window.loading.hide();
            call&&call(false);
            message.destroy();
            message.warning("请先选择主栏目");
            return
        }
        if(!rmPublisher.publishName) {
            window.loading.hide();
            call&&call(false);
            message.destroy();
            message.warning("请先选择需要发布的融媒号！");
            return
        }
        // 存储其他设置
        let {otherSetting={}} = publishData;
        currentInformation.variableFields = {
            ...(currentInformation.variableFields||{}),
            ...otherSetting,
            ...rmPublisher,
            initViewNum: otherAttributes.initViewNum
        };
        if(!currentInformation.variableFields.label) {
            currentInformation.variableFields.label = [];
        }
        let tagNames = currentInformation.variableFields.label;
        window.loading.hide();
        this.LinkCheck.show(content,(res)=>{
            window.loading.show();
            if(res) {
                if(res.content) {
                    this.setContent(res.content);
                }
                if(res.status) {
                    // 稿件数据 start
                    let params = {
                        /**
                         * 表单设置==============================start
                         */
                        ...currentInformation,
                        // 正文
                        "content": base64Encode(removeContentSecurity(res.content || content)),
                        //跳转链接
                        "linkurl":currentInformation.linkurl,
                        // 稿件id
                        "id": id,
                        // 投递信息（副栏目信息）
                        "deliveryMediaFusionList": deliveryNews,
                        tagNames,
                        //同步投递
                        "targetIds": rmSynchronousContribute,
                        /**
                         * 主栏目设置==============================start
                         */
                        // 主媒体id
                        "mediaId": mediaId,
                        //主媒体名称
                        "mediaName": this.state.mediaName,
                        // 主栏目Id int
                        "columnId": columnId,
                        "columnName": columnName,
                        // 发布时间
                        "publishDate": new Date().getTime(),
                        // 是否置顶 int
                        "top": otherAttributes.top,
                        // 是否推荐 int
                        "recommend": otherAttributes.recommend,
                        // 量 int
                        "viewNum": otherAttributes.viewNum,
                        /**
                         * 主栏目设置==================================end
                         */
                    };
                    if(!params.id) {
                        // 新增稿件添加创建人
                        systemBaseEvent.syncExec("editorAddData");
                        let currentUser = window.currentUser ? window.currentUser : {};
                        params={
                            ...params,
                            "submitter": currentUser.id,
                            "submitterName": currentUser.name,
                        };
                    } else {
                        params={
                            ...params,
                            "submitter": this.mediaFusion.submitter,
                            "submitterName": this.mediaFusion.submitterName,
                        };
                        systemBaseEvent.syncExec("editorUpdateData");
                    }
                    // 稿件数据 end
                    let url = '/cm-sites-mmp/mf/save';
                    if(this.publishData?.dbUpdateTime) {
                        // 已经保存过，再次进行保存，需要更新保存时间
                        params.dbUpdateTime = this.publishData.dbUpdateTime
                    }
                    this.request({
                        url,
                        method: 'POST',
                        body: params,
                        contentType: 'json',
                        callBack: async (res) => {
                            if (res) {
                                // 备注，这里必须这样写，稿件保存时不会回显同步投递的参数，但是发布时需要
                                this.publishData = {...params,...res,content: base64Encode(removeContentSecurity(res.content))};
                                // 更新稿件关系（网站稿件与收稿稿件
                                if(that.urlParams && that.urlParams.storyId) {
                                    that.updateStoryRelationByContent({
                                        body: {
                                            mediaNewsId: res.id, // 融媒稿件id
                                            mediaNewsType: "rmapp", // 融媒媒体type
                                            operateType: that.state.operateType, // contribute 点击素材中心标题 / pickUp 点击拾取器
                                            storyId: that.urlParams.storyId, // 原稿件Id(副本）
                                        }
                                    });
                                }
                                this.state.id = res.id;
                                window.loading.hide();
                                systemBaseEvent.syncExec("editorDataChange", res);
                                systemBaseEvent.syncExec("editorIdChange", {editorId: this.state.id});
                                let funs = window.ueditor.afterSaveDataFun;
                                for(let i = 0 ; funs && i < funs.length; i++){
                                    let fun = funs[i];
                                    if(fun instanceof Promise){
                                        await fun(activiti, res, call);
                                    }else{
                                        fun(activiti, res, call);
                                    }
                                }
                                this.state.rmAppContent = res;
                                this.mediaFusion = res;
                                if(isPublish) {
                                    this.securityCheckAsyncCheck({params, activiti, rmAppContent:res, call});
                                }else{
                                    this.securityCheckAsyncCheck({params, activiti, rmAppContent:res, call});
                                }
                                this.updateProcessAndData(this.publishData)
                            } else {
                                message.error('保存失败！');
                                call && call(false);
                            }
                        },
                        errorCallBack: function (e) {
                            call && call(false);
                            message.error('保存失败！');
                        },
                        serverVerify: {
                            serverErrorCallBack: (e,allData) => {
                                window.loading.hide();
                                call && call(false);
                            }
                        }
                    });
                } else {
                    window.loading.hide();
                    call && call(false);
                    return false
                }
            }
        });
    };

    // 更新稿件关系(拾取、复制）
    updateStoryRelationByContent = (config,call) => {
        if(config) {
            if(config.body) {
                this.request({
                    url:"/cm-sites-pms/story/saveRelation",
                    method:"post",
                    body: config.body,
                    callBack: (res) => {
                        if(res) {
                            call&&call(true);
                            console.log("更新稿件关系成功！")
                        }
                    }
                })
            }
        } else {
            call&&call(false);
        }
    };

    // 更新流程稿件
    updateProcessAndData = (body) => {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            body: {
                title: body?.title,
                bizKey: body?.id,
                data: body,
            },
            callBack: (res)=>{

            }
        })
    };

    securityCheckAsyncCheck = ({params, activiti, rmAppContent, call, successMsg = (that, activiti)=>{
        if(!activiti){//点了暂存按钮
            message.success('保存成功！',0.5,()=>{
                that.refresh()
            });
        }
    }})=>{
        let that = this;
        // 某些状态不需要检测敏感词start
        let noDetectionStatus = this.sysConfigGetValueByKey("no.detection.story.statusName", "返回,弃用").split(',');
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        let needDetectionStatus = this.sysConfigGetValueByKey("need.detection.story.statusName", "发布").split(',');
        if (statusNameTemp && noDetectionStatus && noDetectionStatus.some(item => statusNameTemp.indexOf(item) > -1)){
            call && call(rmAppContent);
            that.state.id = rmAppContent.id;
            successMsg(that, activiti);
            return
        }
        if (!(statusNameTemp && noDetectionStatus && ((needDetectionStatus.indexOf("全部") > -1) || needDetectionStatus.some(item => statusNameTemp.indexOf(item) > -1)))){
            call && call(rmAppContent);
            that.state.id = rmAppContent.id;
            successMsg(that, activiti);
            return false
        }
        // if(statusNameTemp && noDetectionStatus && noDetectionStatus.some(item=>statusNameTemp.indexOf(item)>-1)) {
        //     call && call(rmAppContent);
        //     that.state.id = rmAppContent.id;
        //     successMsg(that, activiti);
        //     return
        // }
        // 某些状态不需要检测敏感词end
        if(!window.ueditor.securityCheckAsyncCheck){
            message.warn("敏感词检测失效，无法进行异步检测");
        }else {
            window.ueditor.securityCheckAsyncCheck((content) => {
                window.loading.show();
                call && call(rmAppContent);
                that.state.id = rmAppContent.id;
                successMsg(that, activiti);
            }).catch(() => {
                call && call(false);
                message.error('敏感词检测失败！');
            });
        }
    };

    /**
     * 稿件修改状态
     */
    updateStatusName=(statusName, activiti, call)=> {
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';
        let params = {
            "status":statusName,
        };
        this.request({
            url: '/cm-sites-mmp/mf/status/'+id,
            method: 'POST',
            body: params,
            callBack: function (res) {
                if (res) {
                    call&&call({status: true, msg: "流程推进后状态修改成功。"});
                } else {
                    call&&call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (res) {
                call&&call({status: false, msg: "流程推进后状态修改失败。"});
            }
        });
    };

    publish = (statusName, activiti, call) => {
        if(this.publishData && this.publishData.id) {
            let url = '/cm-sites-mmp/mf/status/'+this.publishData.id;
            this.request({
                url,
                method: 'POST',
                body: {status: "已发布"},
                callBack: () => {
                    call&&call({status: true, msg: "流程推进后发布成功。"});
                },
                errorCallBack: function (e) {
                    call&&call({status: false, msg: "流程推进后发布失败。"});
                }
            });
        } else {
            message.warn("发布失败！稿件id丢失")
        }

    };

    setMainColumn = ({
                         columnId = this.state.columnId,
                         mediaId = this.state.mediaId,
                     }) => {
        this.setState({columnId,mediaId})
    };

    //获取编辑器内容（所有）
    getEditContent() {
        let contentTxt = this.getEditContentText();
        let content = window.ueditor.getContent();
        if(
            !(contentTxt && contentTxt.length) &&
            !(content.indexOf("img") > -1 || content.indexOf("IMG") > -1)
        ) {
            return false
        }
        return content
    }
    //获取编辑器内容（文字）
    getEditContentText() {
        return window.ueditor.getContentTxt();
    }
    //设置编辑器内容
    setContent(content) {
        if (content) {
            window.ueditor.setContent(content)
        }
    }

    //获取稿件基本信息
    getCurrentInformation() {
        return this.editorInformation.getInformation();
    }
    //设置稿件基本信息
    setCurrentInformation(data) {
        this.editorInformation.setInformation(data)
    }

    /**
     * 右侧栏目的设置与获取方法start
     * */
    setPublish = (data) => {
        this.editorPublishInformation.setData(data)
    };
    getPublish = (data) => {
        return  this.editorPublishInformation.getData(data)
    };
    /**
     * 右侧栏目的设置与获取方法end
     * */

}
export default RmAppEditor;
